// extracted by mini-css-extract-plugin
module.exports = {"printable":"styles_printable__nEx3w","nonPrintable":"styles_nonPrintable__TjJuE","container":"styles_container__1SrUZ","icon":"styles_icon__sf1HZ","link":"styles_link__ZCB0A"};